// 附件下载限制下拉枚举
export enum AttachmentDownloadScopeEnum {
	SOMEBODY = 'SOMEBODY',  // 部分人
	NOBODY = 'NOBODY',  // 禁止下载
	EVERYBODY = 'EVERYBODY',    // 所有人可下载
}

// 附件数据源接口
export interface AttachmentDataSource {
	fileName: string;   // 附件名称（带文件后缀）
	attachmentId: string;    // 附件下载id
	downloadCount?: number; // 下载次数
	downloadScope?: AttachmentDownloadScopeEnum; // 附件下载限制
	downloadable?: boolean; // 是否可下载
	previewable?: boolean;  // 是否可预览
	supportPreview?: boolean;   // 是否可支持预览
	size?: string;  // 文件大小
	uploadTime?: string;    // 上传日期
	uploader?: {userId: string, userName: string}; // 上传人信息
}
